import ValidationError from "../validationError";
import {ErrorType} from "~/enums/ErrorType";
import CustomStatus from "../../../formability/form_builder/models/customStatus";
import WorkflowStepAction from "../../../formability/form_builder/models/workflow/workflowStepAction";
import NavigableValidator from "~/models/navigableValidators/navigableValidator";

export default class WorkflowStepActionValidator extends NavigableValidator<WorkflowStepAction> {
  _validatorKey = 'action';
  defaultType = ErrorType.stepRequiresStatus;

  _validate(model: WorkflowStepAction): void {
    let endSteps = model.jumpTos.filter(x => {
      return !x.to_client_id
    });
    endSteps.forEach(endStep => {
      if (!CustomStatus.findByReferenceOrClientId(model.parent.parent.form, endStep.status)) {
        this.errors.push(this.buildValidationError(model, 'Workflow end step requires a status'))
      }
    })
  }

  buildValidationError(model: WorkflowStepAction, value?, type?) {
    return new ValidationError({
      message: value || this.options.message || this.defaultMessage,
      displayName: `${model.titleOrDefault} (end step)`,
      errorNavOpts: model.validation.errorNavOpts(this, 'action', model),
      type: type || this.defaultType,
      section: this.section
    });
  }
}